// queries/getSkills.ts
import { Skill } from '../types';

const staticSkills: Skill[] = [
  // Programming Languages
  { name: "Java", category: "Programming Language", description: "OOP, Enterprise" },
  { name: "JavaScript", category: "Programming Language", description: "Web, Dynamic" },
  { name: "TypeScript", category: "Programming Language", description: "Typed JS" },
  { name: "Python", category: "Programming Language", description: "Backend, Scripting" },
  { name: "C", category: "Programming Language", description: "Systems, Low-level" },

  // Frontend Technologies
  { name: "React", category: "Frontend", description: "UI Library" },
  { name: "Next.js", category: "Frontend", description: "Fullstack React" },
  { name: "Remix", category: "Frontend", description: "Web Framework" },
  { name: "HTML/CSS", category: "Frontend", description: "Markup & Styles" },
  { name: "Tailwind CSS", category: "Frontend", description: "Utility CSS" },
  { name: "Bootstrap", category: "Frontend", description: "UI Framework" },
  { name: "Angular", category: "Frontend", description: "Web Framework" },

  // App Development Technologies
  { name: "React Native", category: "App Development", description: "Cross-Platform Mobile" },
  { name: "Expo", category: "App Development", description: "React Native Toolchain" },
  { name: "Flutter", category: "App Development", description: "Dart Mobile Framework" },
  { name: "Android Dev", category: "App Development", description: "Native Android Apps" },
  { name: "iOS Dev (Swift)", category: "App Development", description: "Native iOS Apps" },
  { name: "App Store", category: "App Development", description: "App Store & Play Store" },

  // Backend Technologies
  { name: "Node.js", category: "Backend", description: "JS Runtime" },
  { name: "Express.js", category: "Backend", description: "Web Server" },
  { name: "Dotnet", category: "Backend", description: "Framework" },

  // Database Technologies
  { name: "PostgreSQL", category: "Database", description: "Relational DB" },
  { name: "MySQL", category: "Database", description: "SQL DB" },
  { name: "MongoDB", category: "Database", description: "NoSQL DB" },
  { name: "Firebase", category: "Database", description: "Realtime DB" },
  { name: "Oracle", category: "Database", description: "Enterprise DB" },

  // DevOps & Tools
  { name: "Git", category: "DevOps", description: "Version Control" },
  { name: "Linux & Bash", category: "DevOps", description: "Shell Scripting" },
  { name: "CI/CD", category: "DevOps", description: "Automation" },
  { name: "Azure Devops", category: "DevOps", description: "Cloud Platform" },
  { name: "Postman", category: "DevOps", description: "API Testing" }
];

export async function getSkills(): Promise<Skill[]> {
  return new Promise((resolve) => {
    setTimeout(() => resolve(staticSkills), 100);
  });
}
